/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import BoardModeSwitcher from 'solis/claude/layout/board.mode.switcher';


export default () =>
(
  <BoardModeSwitcher />
);
